import { useMemo } from 'react';
import * as S from './styled';

interface CardBrandsProps {
  name: string;
}
export const ExtendedCardBrands = () => {
  const EXTENDED_CARD_BRANDS: CardBrandsProps[] = useMemo(
    () => [
      { name: 'visa' },
      { name: 'mastercard' },
      { name: 'paypal' },
      { name: 'applePay' },
      { name: 'googlePay' },
      { name: 'discover' },
      { name: 'amex' },
    ],
    [],
  );
  const renderExtendedCardList = (item: { name: string }) => (
    <img key={item.name} src={`/images/cards/extended_brands/${item.name}.png`} alt={item.name} />
  );
  return (
    <S.ExtendedIconsWrapper>
      {EXTENDED_CARD_BRANDS.map(renderExtendedCardList)}
    </S.ExtendedIconsWrapper>
  );
};
